"use client";

// Banner privasi/cookie per-toko (UU PDP) — pemberitahuan INFORMATIF yang bisa
// ditutup, default MATI (toggle di /admin/settings/pixel). SENGAJA tidak
// memblokir pixel: banner opt-in yang menahan pixel akan melumpuhkan data
// iklan penyewa; bila kelak butuh consent-gating sungguhan, itu fitur
// terpisah dengan keputusan produk sendiri.
//
// Tampil di SEMUA halaman storefront TERMASUK katalog reseller /toko (beda
// dari guard pixel: pemberitahuan privasi relevan di mana pun cookie dipakai)
// — hanya /admin, /platform, dan host platform yang dikecualikan. "Mengerti"
// disimpan per-toko di localStorage; gagal baca/tulis (private mode) berarti
// banner tampil lagi kunjungan berikutnya — bukan masalah.

import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import { isPlatformHost } from "@/lib/platformHost";
import {
  DEFAULT_PRIVACY_BANNER_TEXT,
} from "@/lib/siteSettings";
import { fetchSiteSettings } from "@/lib/supabase/siteSettings";
import { getClientStoreId } from "@/lib/supabase/storeContextClient";

const ACK_KEY_PREFIX = "mh-privacy-ack:";

export function PrivacyBanner() {
  const pathname = usePathname();
  const [text, setText] = useState<string | null>(null);
  const [acked, setAcked] = useState(true); // pesimis: jangan berkedip

  useEffect(() => {
    if (isPlatformHost(window.location.hostname)) return;
    const storeId = getClientStoreId();
    if (!storeId) return;
    let alive = true;
    try {
      if (localStorage.getItem(ACK_KEY_PREFIX + storeId)) return;
    } catch {
      /* private mode → anggap belum ack */
    }
    fetchSiteSettings()
      .then((s) => {
        if (!alive || !s.privacyBannerEnabled) return;
        setText(s.privacyBannerText || DEFAULT_PRIVACY_BANNER_TEXT);
        setAcked(false);
      })
      .catch(() => undefined);
    return () => {
      alive = false;
    };
  }, []);

  // Dicek per render (bukan hanya mount): navigasi SPA ke /admin tidak
  // me-remount komponen ini.
  if (
    acked ||
    !text ||
    pathname.startsWith("/admin") ||
    pathname.startsWith("/platform")
  ) {
    return null;
  }

  const dismiss = () => {
    setAcked(true);
    try {
      const storeId = getClientStoreId();
      if (storeId) localStorage.setItem(ACK_KEY_PREFIX + storeId, "1");
    } catch {
      /* private mode → tampil lagi kunjungan berikutnya */
    }
  };

  return (
    <div className="fixed bottom-20 left-1/2 z-40 w-[calc(100%-1.5rem)] max-w-md -translate-x-1/2 rounded-2xl border border-neutral-100 bg-white p-3 shadow-soft safe-bottom">
      <p className="text-[11px] font-semibold leading-5 text-muted">{text}</p>
      <button
        type="button"
        onClick={dismiss}
        className="mt-2 h-9 w-full rounded-lg bg-shopee text-xs font-extrabold text-white transition active:scale-[0.99]"
      >
        Mengerti
      </button>
    </div>
  );
}
